import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

const APP_META_TAGS = [
  process.env.APP_DISABLE_CRAWLING === 'true'
    ? { name: 'robots', content: 'noindex, nofollow' }
    : {},
];

function AppHelmet() {
  const { locale } = useIntl();

  return <Helmet htmlAttributes={{ lang: locale }} meta={APP_META_TAGS} />;
}

export default AppHelmet;
